@if (!tieneCredenciales) {
  <mat-card class="aviso-creds">
    <mat-card-content>
      <mat-icon color="warn">key</mat-icon>
      <div class="aviso-texto">
        <h3>Credenciales de seguridad no configuradas</h3>
        <p>
          Para ver las alertas es necesario colocar tus credenciales de usuario
          del sistema de seguridad.
          <br />
          <strong>
            Configuración → Configurar usuario → Credenciales de Seguridad
          </strong>
          .
        </p>
      </div>
    </mat-card-content>
  </mat-card>
} @else {
  <mat-tab-group [(selectedIndex)]="selectedTab" class="alertas-tabs">
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">crisis_alert</mat-icon>
        Activas
        <span class="badge">{{ solapas.activas.totalCount }}</span>
      </ng-template>
      <ng-template matTabContent>
        <div class="tab-body">
          <!-- Clic delegado: abre la foto del vecino de la columna de avatar -->
          <app-tabla
            (click)="onVecinoFotoClick($event)"
            [totalCount]="solapas.activas.totalCount"
            [datos]="solapas.activas.datos"
            [columnas]="solapas.activas.columnas"
            [name]="solapas.activas.name"
            [pageSizeOptions]="helper.pageSizeOptions"
            [busquedaLocal]="{
              placeholder:
                'Buscar en alertas activas (nombre, dirección, teléfono, DNI…)',
            }"
            [(query)]="solapas.activas.query"
            (queryChange)="listarSolapa(solapas.activas)"
            [paginatorArriba]="false"
            [paginatorAbajo]="false"
            [showHijos]="false"
            [crear]="botonCrear"
            [exportar]="botonExportarActivas"
            [emptyState]="{ title: 'No hay alertas activas' }"
          ></app-tabla>
        </div>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">task_alt</mat-icon>
        Finalizadas
        <span class="badge">{{ solapas.finalizadas.totalCount }}</span>
      </ng-template>
      <ng-template matTabContent>
        <div class="tab-body">
          <!-- Clic delegado: abre la foto del vecino de la columna de avatar -->
          <app-tabla
            (click)="onVecinoFotoClick($event)"
            [totalCount]="solapas.finalizadas.totalCount"
            [datos]="solapas.finalizadas.datos"
            [columnas]="solapas.finalizadas.columnas"
            [name]="solapas.finalizadas.name"
            [pageSizeOptions]="helper.pageSizeOptions"
            [search]="solapas.finalizadas.search"
            [filtros]="solapas.finalizadas.filtros"
            [(query)]="solapas.finalizadas.query"
            (queryChange)="listarSolapa(solapas.finalizadas)"
            [paginatorArriba]="false"
            [showHijos]="false"
            [exportar]="botonExportarFinalizadas"
            [emptyState]="{ title: 'Todavía no hay alertas finalizadas' }"
          ></app-tabla>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
}

<app-image-viewer
  [imageUrl]="fotoVecinoActual"
  [isVisible]="mostrarVisorFotoVecino"
  altText="Foto del vecino"
  (closeViewer)="mostrarVisorFotoVecino = false"
></app-image-viewer>
